const getNumberOfDecimalPlaces = (value: number) => {
	const numberAsString = value.toString();
	const decimalPointPosition = numberAsString.indexOf('.');
	if (decimalPointPosition === -1) {
		return 0;
	}
	// return substring from decimal place onwards
	return numberAsString.slice(decimalPointPosition + 1).length;
};

export const safeAdd = (valueA: number, valueB: number) => {
	const valueALength = getNumberOfDecimalPlaces(valueA);
	const valueBLength = getNumberOfDecimalPlaces(valueB);

	// use the larger length to determine offset
	const arithmaticOffset = valueALength > valueBLength
		? valueALength
		: valueBLength;

	const multiplier = 10 ** arithmaticOffset;

	return ((valueA * multiplier) + (valueB * multiplier)) / multiplier;
};

export const safeSubtract = (valueA: number, valueB: number) => safeAdd(valueA, (valueB * -1));
